// removed by extract-text-webpack-plugin
module.exports = {"oneMonthBanner":"BannerContainer__oneMonthBanner"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/BannerContainer/BannerContainer.scss
// module id = 1735
// module chunks = 8